import { render, staticRenderFns } from "./income-info.vue?vue&type=template&id=d919e142&scoped=true&"
import script from "./income-info.vue?vue&type=script&lang=js&"
export * from "./income-info.vue?vue&type=script&lang=js&"
import style0 from "./income-info.vue?vue&type=style&index=0&id=d919e142&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d919e142",
  null
  
)

export default component.exports